import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './profile-page-enhancement.component.scss';
var ProfilePageEnhancement = /** @class */ (function (_super) {
    tslib_1.__extends(ProfilePageEnhancement, _super);
    function ProfilePageEnhancement(element) {
        return _super.call(this, element) || this;
    }
    ProfilePageEnhancement.prototype.init = function () {
    };
    ProfilePageEnhancement.prototype.bindEvents = function () {
    };
    return ProfilePageEnhancement;
}(Base));
export { ProfilePageEnhancement };



//////////////////
// WEBPACK FOOTER
// ./components/profile-page-enhancement/profile-page-enhancement.component.ts
// module id = 464
// module chunks = 0